import React, { useContext, useState } from "react";

import { DataContext } from "../../../../../../providers/PelletsCheckoutDataProvider";
import Checkbox from "../../../../../shared/forms/Checkbox";
import FormError from "../../../../../shared/forms/FormError";
import PdfModal from "../../../../../shared/PdfModal";
import { TermsOfServiceModalActivator } from "../../../../Shop/Checkout/StepSummary";
import * as styles from "./style.module.scss";

const defaultModalData = {
    documentPath: "",
    title: "",
    isVisible: false,
};

const Agb = () => {
    const dataContext = useContext(DataContext);

    const { agbChecked } = dataContext.data;
    const { setAgbChecked, hasFormErrorAt } = dataContext.actions;
    const [modalData, setModalData] = useState(defaultModalData);

    const showTermsModal = (event, documentPath, title) => {
        event.preventDefault();
        setModalData({
            documentPath: documentPath,
            title: title,
            isVisible: true,
        });
    };

    return (
        <React.Fragment>
            <PdfModal
                title={modalData.title}
                pdfPath={modalData.documentPath}
                pdfScale={1.25}
                isVisible={modalData.isVisible}
                onClose={() => setModalData(defaultModalData)}
            />
            <div className={styles.checkboxRow}>
                <div>
                    <Checkbox
                        className={styles.checkbox}
                        checked={agbChecked}
                        onClick={() => {
                            setAgbChecked(!agbChecked);
                        }}
                    />
                </div>
                <div className={styles.checkboxLabel}>
                    <span>
                        <span>
                            Ich erkenne die{" "}
                            <TermsOfServiceModalActivator
                                onClick={(event) =>
                                    showTermsModal(
                                        event,
                                        "/img/Hoyer_AGB_Unternehmensgruppe.pdf",
                                        "AGB"
                                    )
                                }
                            >
                                AGB
                            </TermsOfServiceModalActivator>{" "}
                            an und habe die{" "}
                            <TermsOfServiceModalActivator
                                onClick={(event) =>
                                    showTermsModal(
                                        event,
                                        "/img/11.RET-XXX.FB001_Widerrufsbelehrung.pdf",
                                        "Widerrufsbelehrung"
                                    )
                                }
                            >
                                Widerrufsbelehrung
                            </TermsOfServiceModalActivator>{" "}
                            gelesen.
                        </span>
                    </span>
                </div>
            </div>
            {hasFormErrorAt("agb") && (
                <FormError message="Bitte akzeptieren Sie die AGB." />
            )}
        </React.Fragment>
    );
};

export default Agb;
